// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__FfCSj","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1c5Rw","gfeWrapper":"CalendarEvent_gfeWrapper__1-rbX"};